import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    
    const api = await getAxiosInstance();
    const getParams = (key) => {
    
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?${getParams("start_date")}${getParams(
          "end_date"
        )}${getParams("filter")}${getParams("sort_by")}is_active=${
          params?.is_active ? params["is_active"] : 0
        }&sort_order=${
          params?.sort_order || "desc"
        }&page_size=${params?.page_size || "10"}&${getParams("search")}page=${
          params?.page || 1
        }`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const product = createApi({
  reducerPath: "productApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["product"],
  endpoints: (builder) => ({
    getListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/products`,
      }),
      providesTags: ["product"],
    }),
    createNew: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/admin/frame-type/create`,
      }),
      invalidatesTags: ["product"],
    }),
    updateTableFieldsData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/admin/user/fields/update`,
      }),

      invalidatesTags: ["product"],
    }),
    updateStatusById: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `admin/products/change/status`,
      }),

      // invalidatesTags: ["product"],
    }),
  }),
});

export const { useGetListDataQuery, useCreateNewMutation, useUpdateTableFieldsDataMutation, useUpdateStatusByIdMutation } = product;
